<su-slot-tabs [tabs]="tabs" [activeTab]="activeTab"></su-slot-tabs>

<su-slot-tab-content *ngIf="activeTab === tabs[0].id">
  <app-detail-fields-base
    *ngIf="!isLoading && data && (incident || task || buildingDocument())"
    [allowFileUpload]="config.showFileUpload"
    [detailFields]="detailFields"
    [data]="data"
    [incident]="incident"
    [showFileList]="showFileList"
    [buildingDocument]="buildingDocument()"
    [hasDocumentTypeSelection]="hasDocumentTypeSelection"
    [hasDocumentVisibilitySelection]="hasDocumentVisibilitySelection"
    [defaultDocumentTypeValue]="defaultDocumentTypeValue"
    [defaultDocumentVisibilityValue]="
      defaultDocumentVisibilityValue
    "></app-detail-fields-base>
  <ng-template appPlaceholder></ng-template>
</su-slot-tab-content>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
